import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export function useUpdateCustomPriceFreight() {
  const [loading, setLoading] = useState(false);
  async function execute(
    freightId: string,
    body: {
      freightCost: string;
    },
  ) {
    try {
      setLoading(true);
      console.log('[useUpdateCustomPriceFreight] Salvando valor customizado:', {
        freightId,
        freightCost: body.freightCost,
      });
      
      const response = await api.patch(
        `v1/backoffice/freights/${freightId}/customPriceFreight`,
        {
          freightCost: body.freightCost,
        },
      );

      if (response.status === 200) {
        console.log('[useUpdateCustomPriceFreight] ✅ Valor customizado salvo com sucesso');
        toast.success(ToastMessages.general.success.operationSuccess);
      } else {
        console.warn('[useUpdateCustomPriceFreight] ⚠️ Status diferente de 200:', response.status);
      }
    } catch (error: any) {
      console.error('[useUpdateCustomPriceFreight] ❌ Erro ao salvar valor customizado:', {
        message: error?.message,
        response: error?.response?.data,
        status: error?.response?.status,
      });
      toast.error(ToastMessages.general.error.genericError);
    } finally {
      setLoading(false);
    }
  }
  return { execute, loading };
}
